import {types} from '../../types';

const setGetViewKeysAction = (payload) => {
    return {
        type: types.common.SET_VIEW_KEYS,
        payload,
      }
}

export {
  setGetViewKeysAction as SetGetViewKeysAction
}
